import React, { useEffect, useState } from "react";
import { ReportsApi } from "../../../../../../core/api/reportsApi";
import { directionToRatingVariant, } from "../HomeIndexListing/homeIndexListingData";
import HomeIndexChart from "./HomeIndexChart";
import "./homeIndex.scss";
/**
 * Figma `1:4547` — HOME INDEX card; layout/typography/assets from MCP `get_design_context`.
 * Chart region `1:4550` is implemented with Recharts (`HomeIndexChart`).
 */
const HomeIndex = () => {
    const [predictionOutlook, setPredictionOutlook] = useState("");
    const [predictionDetail, setPredictionDetail] = useState("");
    const [predictionDirectionVariant, setPredictionDirectionVariant] = useState(null);
    useEffect(() => {
        let cancelled = false;
        ReportsApi.getCompositeIndexPrediction()
            .then((res) => {
            var _a, _b, _c;
            if (cancelled || !res) {
                return;
            }
            const days = (_a = res.daysUntilPredictedStatus) !== null && _a !== void 0 ? _a : "";
            const direction = (_b = res.predictionDirection) !== null && _b !== void 0 ? _b : "";
            const percentage = (_c = res.predictionPercentage) !== null && _c !== void 0 ? _c : "";
            setPredictionOutlook(!days ? null : `PREDICTED ${days}-DAY OUTLOOK`);
            setPredictionDetail(percentage
                ? `${direction} ${direction === "Improving" ? "▲" : direction === "Worsening" ? "▼" : ""} ${percentage}%`.trim()
                : null);
            setPredictionDirectionVariant(directionToRatingVariant(direction));
        })
            .catch(() => {
            if (!cancelled) {
                setPredictionOutlook("");
                setPredictionDetail("");
                setPredictionDirectionVariant(null);
            }
        });
        return () => {
            cancelled = true;
        };
    }, []);
    return (React.createElement("div", { className: "home-index", "data-node-id": "1:4547" },
        React.createElement("div", { className: "home-index__gradient", "aria-hidden": true }),
        React.createElement("div", { className: "home-index__heading", "data-node-id": "1:4548", "data-name": "Heading 3" },
            React.createElement("div", { className: "home-index__title-wrap", "data-node-id": "1:4549" },
                React.createElement("p", { className: "home-index__title" }, "RODABI INDEX"))),
        React.createElement(HomeIndexChart, null),
        React.createElement("div", { className: "home-index__footer", "data-node-id": "1:4551", "data-name": "Container" },
            React.createElement("div", { className: "home-index__footer-left", "data-node-id": "1:4552", "data-name": "Container" },
                React.createElement("div", { className: "home-index__footer-muted-wrap", "data-node-id": "1:4553" },
                    React.createElement("p", { className: "home-index__footer-muted" }, predictionOutlook
                        ? predictionOutlook
                        : "Prediction not available because of insufficient data"))),
            React.createElement("div", { className: "home-index__footer-right", "data-node-id": "1:4554", "data-name": "Container" },
                React.createElement("div", { className: "home-index__footer-accent-wrap", "data-node-id": "1:4555" }, predictionDetail ? (React.createElement("p", { className: `home-index__footer-accent${predictionDirectionVariant
                        ? ` home-index__footer-accent--${predictionDirectionVariant}`
                        : ""}` }, predictionDetail)) : null))),
        React.createElement("div", { className: "home-index__inset-shadow", "aria-hidden": true })));
};
export default HomeIndex;
